// extracted by mini-css-extract-plugin
export default {"wrapper":"b562dfa7bebc","content":"bc3b5ad5038c"};